import API from '../../config/axiosConfig';

const API_URL = '/api/checklists';

export const getChecklistTemplates = async () => {
    try {
        const response = await API.get(`${API_URL}/templates`);
        return response.data;
    } catch (error) {
        console.error('Error fetching checklist templates:', error);
        throw error;
    }
};

export const getChecklistTemplateById = async (templateId) => {
    try {
        const response = await API.get(`${API_URL}/templates/${templateId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching checklist template ${templateId}:`, error);
        throw error;
    }
};

export const createChecklistTemplate = async (templateData) => {
    try {
        const response = await API.post(`${API_URL}/templates`, templateData);
        return response.data;
    } catch (error) {
        console.error('Error creating checklist template:', error);
        throw error;
    }
};

export const updateChecklistTemplate = async (templateId, templateData) => {
    try {
        const response = await API.put(`${API_URL}/templates/${templateId}`, templateData);
        return response.data;
    } catch (error) {
        console.error(`Error updating checklist template ${templateId}:`, error);
        throw error;
    }
};

export const getChecklistInstance = async (instanceId) => {
    try {
        const response = await API.get(`${API_URL}/instances/${instanceId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching checklist instance ${instanceId}:`, error);
        throw error;
    }
};

export const createChecklistInstance = async (templateId, patientId) => {
    try {
        const response = await API.post(`${API_URL}/instances`, { templateId, patientId });
        return response.data;
    } catch (error) {
        console.error('Error creating checklist instance:', error);
        throw error;
    }
};

export const getChecklistInstances = async (departmentId, patientId) => {
    try {
        const response = await API.get(`${API_URL}/instances/by-patient/${departmentId}/${patientId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching checklist instances:', error);
        throw error;
    }
};

export const updateChecklistInstance = async (instanceId, instanceData) => {
    try {
        const response = await API.put(`${API_URL}/instances/${instanceId}`, instanceData);
        return response.data;
    } catch (error) {
        console.error(`Error updating checklist instance ${instanceId}:`, error);
        throw error;
    }
};

export const updateChecklistItem = async (instanceId, groupId, itemId, itemData) => {
    try {
        const response = await API.put(`${API_URL}/instances/${instanceId}/groups/${groupId}/items/${itemId}`, itemData);
        return response.data;
    } catch (error) {
        console.error(`Error updating checklist item ${itemId}:`, error);
        throw error;
    }
};

export const deleteChecklistTemplate = async (templateId) => {
    try {
        const response = await API.delete(`${API_URL}/templates/${templateId}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting checklist template ${templateId}:`, error);
        throw error;
    }
};

export const getAllChecklistInstances = async () => {
    try {
        const response = await API.get(`${API_URL}/instances`);
        return response.data;
    } catch (error) {
        console.error('Error fetching all checklist instances:', error);
        throw error;
    }
};

export const deleteChecklistInstance = async (instanceId) => {
    try {
        const response = await API.delete(`${API_URL}/instances/${instanceId}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting checklist instance ${instanceId}:`, error);
        throw error;
    }
};

export const exportChecklistTemplate = async (templateId) => {
    try {
        const response = await API.get(`${API_URL}/templates/${templateId}/export`);
        return response.data;
    } catch (error) {
        console.error(`Error exporting checklist template ${templateId}:`, error);
        throw error;
    }
};

export const importChecklistTemplate = async (templateData) => {
    try {
        // handlingErrorLocally: ChecklistTemplatesList shows the reason inline
        // next to the import button, so the floating toast would repeat it.
        const response = await API.post(`${API_URL}/templates/import`, templateData, { handlingErrorLocally: true });
        return response.data;
    } catch (error) {
        console.error('Error importing checklist template:', error);
        throw error;
    }
};